<template>
    <transition name="fade">
        <div id="del_popup" v-if="isVisible" @click="close">
            <div class="del_popup" @click.stop>
                <div class="del_popup1">
                    <div class="del_popup1_1">
                        <img :src="delPrompt[delIndex].icon" alt="">
                        提醒
                    </div>
                    <img class="del_popup1_2" src="../assets/image/icon_close.png" alt="" @click="close">
                </div>
                <div class="del_popup2">{{ delPrompt[delIndex].text }}</div>
                <div class="del_popup3">
                    <div class="del_popup3_1" :style="{ background: delPrompt[delIndex].color }"
                        @click="confirmSelect">
                        确认
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import api from '@/api/api';
import data from '@/assets/data';
export default {
    data() {
        return {
            delPrompt: data.delPrompt, // 删除文本提示
            delIndex: null, //显示内容下标
            isVisible: false,
            isAllDel:false,//是否全部删除
        };
    },
    methods: {
        openPrompt(i,isAllDel=false) {
            this.delIndex = i;
            this.isVisible = true;
            this.isAllDel = isAllDel
        },
        close() {
            this.isVisible = false;
        },
        confirmSelect() {
            // 处理确认逻辑
            if (this.delIndex == 0 || this.delIndex == 3 || this.delIndex == 4 || this.delIndex == 5) {
                this.isVisible = false;
                this.$emit('confirm',this.isAllDel) 
                sessionStorage.removeItem('streamStatus');
            } else if (this.delIndex == 2) {
                this.logout()
            }else if (this.delIndex == 1 || this.delIndex == 6 || this.delIndex == 7) {
                this.isVisible = false;
            }
        },
        logout() {
            api.logout().then((res) => {
                if (res.code == 200) {
                    this.$message({
                        message: "退出成功！",
                        type: "success",
                    });
                    localStorage.removeItem("token_key");
                    window.location.reload()
                    this.$router.push({ path: '/' });
                }
            })
        }
    }
};
</script>

<style>
#del_popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(14, 14, 14, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.del_popup {
    background-color: #FFF;
    padding: 15px 20px;
    border-radius: 10px;
}

.del_popup1 {
    width: 260px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.del_popup1_1 {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 15px;
    color: #18191A;
}

.del_popup1_1 img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}

.del_popup1_2 {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.del_popup2 {
    width: 260px;
    font-size: 16px;
    color: #000000;
    margin: 15px 0;
}

.del_popup3 {
    width: 260px;
    display: flex;
    justify-content: end;
}

.del_popup3_1 {
    width: 83px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    color: #FFFFFF;
    /* background: var(--tech-primary); */
    border-radius: 4px;
    cursor: pointer;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>